// import styles from './SecondaryAdBanner.module.css';
import { useContext, useState, useMemo } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
} from "react-bootstrap";
import VideoContext from "../../store/video-context";
import { toast } from "react-toastify";
import countryList from "react-select-country-list";
import "react-phone-number-input/style.css";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { countries } from "../../store/country-list";
import ReactGA from 'react-ga';
// import lookup from "country-code-lookup";

const AdPopup = (props: any) => {
  const options = useMemo(() => countryList().getData(), []);
  const vContext = useContext(VideoContext);
  //alert(props.timePlaceholder);
  const [timePlaceholder, setTimePlaceholder] = useState(props.timePlaceholder);
  const [timePlaceholderError, setTimePlaceholderError] = useState(props.timePlaceholderError);
  
  //const [adData, setAdData] = useState(props.data[0]);
  let test = 0;

  const updateProfile = () => {
    let data: { [index: string]: any } = { command: "updateProfile" };
    if (firstName !== "") {
      data.firstName = firstName;
    }
    if (lastName !== "") {
      data.lastName = lastName;
    }
    if (email !== "") {
      data.email = email;
    }
    if (phoneNo !== "") {
      let parseNumber = parsePhoneNumber(phoneNo);
      data.mobile = parseNumber!.nationalNumber;
      data.country_code = parseNumber!.countryCallingCode;
    }
    if (city !== "") {
      data.city = city;
    }
    if (country !== "") {
      data.country = country;
    }

    if (vContext.userId !== "") {
      data.userID = vContext.userId;
    }
    console.log("data", data);

    // add data.timeinput 


    if(timeinput){
      fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), //JSON.stringify({a: 1, b: 'Textual content'})
    })
      .then((res) => res.json())
      .then((updateProfileData) => {
        if (updateProfileData.status === "success") {
      toast.dark("Profile Updated Successfully!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      setShow(false);
    } else {
      // console.log("Fail update profile")
      toast.dark("Update Profile Failed!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  })
  .catch((error) => {
    console.error("Error:(handleSubmit)", error);
  });

    }
   
  };

  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [firstName, setFirstName] = useState(vContext.userData.user_first_name);
  const [lastName, setLastName] = useState(vContext.userData.user_last_name);
  const [email, setEmail] = useState(vContext.userData.user_email);
  const [phoneNo, setPhoneNo] = useState(
    vContext.userData.user_phone_no.trim() === ""
      ? ""
      : "+" + vContext.userData.country_code + vContext.userData.user_phone_no
  );
  const [invalidPhone, setInvalidPhone] = useState(false);
  const [city, setCity] = useState(vContext.userData.user_city);
  const [country, setCountry] = useState(vContext.userData.user_country);
  const [blank, setBlank] = useState(false);
  const [contcode, setcontcode] = useState(true);
  const [timeinput, setTimeInput] = useState("");
  

  const convertTimeToString = timeinput.replace(/\s+/g, "");
  //console.log(convertTimeToString + "yes");


  console.log("yes" + vContext.userData.country_code);
  const closeAdModal = (event: any) => {
    setShow(false);
  };

  const changeHandler = (value: any) => {
    setPhoneNo(value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      if (!phoneNo) {
        setBlank(true);
      } else {
        let parseNumber = parsePhoneNumber(phoneNo);
        setBlank(false);
        if (parseNumber?.countryCallingCode == undefined) {
          setcontcode(false);
        } else if (parseNumber!.countryCallingCode == "91") {
          setcontcode(true);
          if (parseNumber!.nationalNumber.length != 10) {
            setInvalidPhone(true);
          } else {
            setInvalidPhone(false);
            updateProfile();
            ProductEnquiryApi(e);
            // props.oncloseEvent();
          }
        } else if (parseNumber!.nationalNumber.length < 5) {
          setInvalidPhone(true);
          setcontcode(true);
        } else {
          setBlank(false);
          setcontcode(true);
          setInvalidPhone(false);
          updateProfile();
          // props.oncloseEvent();
          ProductEnquiryApi(e);
        }
      }
    }

    setValidated(true);

  };


  const ProductEnquiryApi = (advData: any) => {
    console.log("ProductEnquiryApi")
 if(vContext.isInstrumentEnquiry){
  let taggedID = vContext.instrumentEnquiry.id !== undefined ? vContext.instrumentEnquiry.id : "0";
   fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveEquipmentEnquiry&transID="+vContext.transId+"&equipmentID="+ vContext.instrumentEnquiry.equipment_id+"&taggedID="+taggedID+"&userID="+vContext.userId+"&confirm=1&time="+timeinput)
    .then(res=>res.json())
    .then((instrumentEnquirey)=>{
      // console.log("instrumentEnquirey", instrumentEnquirey);
      if(instrumentEnquirey.status === "success"){
        // vContext.deleteAccordionDataHandler(id);
        toast.dark("Intrument Enquiry Successfully Captured!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
        // console.log('enquiry details successfully captured');
      }else{
        // console.log("fail delete anatomy");
        toast.dark("Intrument Enquiry Failed!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    })
    .catch((error)=>{
      console.error('Error:(ProductEnquiryApi)', error);
    })
    if (vContext.instrumentEnquiry.equipment_link !== undefined && vContext.instrumentEnquiry.equipment_link !== "") {
      window.open("" + vContext.instrumentEnquiry.equipment_link, "_blank");
    }    

 }else{   let data: { [index: string]: any } = { command: "saveProductEnquiry" };
    data.userID = vContext.userId;
    data.transID = vContext.transId;
    data.productName = vContext.enquiryProduct.product_name;
    data.confirm = "1";
    data.time = timeinput;
      fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), //JSON.stringify({a: 1, b: 'Textual content'})     
    }).then((res) => res.json())
      .then((productEnquiryResponse) => {
              console.log("productEnquiryResponse", productEnquiryResponse);
              if (productEnquiryResponse.status === "success") {
                console.log("product enquiry details captured!")
            if(vContext.enquiryProduct.product_name)
            {
              
              if(vContext.enquiryProduct.product_name.toLowerCase().includes("mot")== true || vContext.enquiryProduct.product_name.toLowerCase().includes("skilllabtalktoexpert")== true)
              {
                ReactGA.event({
                  category: 'Player Page',
                  action: "Ad enquiry",
                  label: vContext.enquiryProduct.product_name
                });

              }
            }
    
                toast.dark(
                  "We have forwarded your details and the device manufacturer will get in touch with you soon",
                  {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  }
                );
              } else {
                // console.log("product enquiry failed");
                toast.dark("Something went wrong!", {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              }

            })
            .catch((error) => {
              console.error("Error:(clickedOnAd)", error);
            });
            
            if (vContext.enquiryProduct.link !== undefined && vContext.enquiryProduct.link !== "") {
              window.open(vContext.enquiryProduct.link);
            }
          }           
          props.oncloseEvent();      
          advData.stopPropagation();
    

  }


  const handlerEnquiryAccordionItem = (e: any, item: any) => {
    // console.log('item',item);
    // console.log('e',e);
    e.stopPropagation();
    if (item.equipment_link !== undefined && item.equipment_link !== "") {
      window.open("" + item.equipment_link, "_blank");
    }
    let taggedID = item.id !== undefined ? item.id : "0";
    // fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=saveEquipmentEnquiry&transID="+vContext.transId+"&equipmentID="+item.equipment_id+"&taggedID="+taggedID+"&userID="+vContext.userId)
    // .then(res=>res.json())
    // .then((instrumentEnquirey)=>{
    //   // console.log("instrumentEnquirey", instrumentEnquirey);
    //   if(instrumentEnquirey.status === "success"){
    //     // vContext.deleteAccordionDataHandler(id);
    //     toast.dark("Intrument Enquiry Successfully Captured!", {
    //       position: "top-center",
    //       autoClose: 5000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       });
    //     // console.log('enquiry details successfully captured');
    //   }else{
    //     // console.log("fail delete anatomy");
    //     toast.dark("Intrument Enquiry Failed!", {
    //       position: "top-center",
    //       autoClose: 5000,
    //       hideProgressBar: true,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       });
    //   }
    // })
    // .catch((error)=>{
    //   console.error('Error:(handlerEnquiryAccordionItem)', error);
    // })
  };




  return (
    <>
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#087CB9", color: "White" }}
      >
        {/* <Modal.Title>Product Enquiry</Modal.Title> */}
        <Modal.Title> I'm interested in knowing more</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <p>Please Confirm your contact details</p> */}
        <p>Confirm your contact details and someone will get back to you with more details on the product soon.</p>
        <p style={{ color: "red" }} className="m-0">
          Please fill all mandatory fields with *
        </p>{" "}
      </Modal.Body>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Form.Group as={Col} controlId="email">
          <Form.Control
            required
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e: any) => {
              setEmail(e.target.value);
            }}
          />
          <Form.Control.Feedback type="invalid">
            {" "}
            Please provide a valid Email.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} controlId="phone" id="phoneinput">
          <PhoneInput
            displayInitialValueAsLocalNumber
            placeholder="Enter Phone Number"
            value={phoneNo}
            onChange={changeHandler}
          />
          {invalidPhone ? (
            <div
              style={{
                color: "#dc3545",
                marginTop: "0.25rem",
                fontSize: "80%",
                fontFamily: "default",
              }}
            >
              Please enter valid Phone Number.
            </div>
          ) : (
            " "
          )}
          {blank ? (
            <div
              style={{
                color: "#dc3545",
                marginTop: "0.25rem",
                fontSize: "80%",
                fontFamily: "default",
              }}
            >
              Phone Number cannot be blank.
            </div>
          ) : (
            " "
          )}
          {/* {contcode ? (
            " "
          ) : (
            <div
              style={{
                color: "#dc3545",
                marginTop: "0.25rem",
                fontSize: "80%",
                fontFamily: "default",
              }}
            >
              Invalid country code
            </div>
          )} */}
        </Form.Group>

        <Form.Group as={Col} controlId="firtname">
          <Form.Control
            required
            type="text"
            placeholder="First name"
            value={firstName}
            onChange={(e: any) => {
              setFirstName(e.target.value);
            }}
          />
          <Form.Control.Feedback type="invalid" id="invalidphone">
            {" "}
            Please provide a valid first Name.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} controlId="lastname">
          <Form.Control
            required
            type="text"
            placeholder="Last name"
            value={lastName}
            onChange={(e: any) => {
              setLastName(e.target.value);
            }}
          />
          <Form.Control.Feedback type="invalid">
            {" "}
            Please provide a valid last Name.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} controlId="city">
          <Form.Control
            type="text"
            placeholder="City"
            required
            value={city}
            onChange={(e: any) => {
              setCity(e.target.value);
            }}
          />
          <Form.Control.Feedback type="invalid">
            Please provide a valid city.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} controlId="country">
          <Form.Control
            required
            as="select"
            custom
            value={country}
            onChange={(e: any) => {
              setCountry(e.target.value);
            }}
          >
            <option value={""}>Select Country</option>
            {countries.map((item: any) => (
              <option value={item.name}>{item.name}</option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            Please provide a valid Country.
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} controlId="timetocall" id="timeinput">
          <Form.Control
            type="text"
            required
            placeholder={timePlaceholder}
            onChange={(e: any) => setTimeInput(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            {timePlaceholderError}
          </Form.Control.Feedback>
        </Form.Group>

        <Modal.Footer>
          <Button type="submit" variant="primary">
            Confirm
          </Button>
        </Modal.Footer>
      </Form>
    </>
  );
};

export default AdPopup;
